import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Checkbox from '@material-ui/core/Checkbox';
import { backgroundColor } from 'echarts/lib/theme/dark';
import DataIconsTooltip from '../Tooltip/DataIconsTooltip';

function StyledCheckbox(props) {
    const classes = useStyles();
   
  
    return (
      <Checkbox
        className={classes.rootC}
        disableRipple
        color="default"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        icon={<span className={classes.icon} />}
        inputProps={{ 'aria-label': 'decorative checkbox' }}
        {...props}
      />
    );
  }
  const useStyles = makeStyles((theme) => ({
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#ffffff',
        '$root.Mui-focusVisible &': {
          outline: '2px auto rgba(19,124,189,.6)',
          outlineOffset: 2,
        },
        'input:hover ~ &': {
          backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
          boxShadow: 'none',
          background: 'rgba(206,217,224,.5)',
        },
      },
      checkedIcon: {
        backgroundColor: '#2563EB',
        boxShadow: 'none',
        '&:before': {
          display: 'block',
          width: 16,
          height: 16,
          backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
          content: '""',
        },
        'input:hover ~ &': {
          backgroundColor: '#2563EB',
        },
      }
}));
const StationCard = props => {
  const {cardOut,cardOver}=props
  useEffect(()=>{
  },[props.toggleMarkerBasedOnLaneGeometryLayer, props.toggleMarkerBasedOnCapacityLayer])

  return (
        <Card className={props.clss && props.clss!=''?props.clss:'details-main-info'} style={props.fixed?{position:'fixed',zIndex:1000}:{}}
        onMouseOver={typeof cardOver === "function"?() => cardOver(props.stationData.latitude, props.stationData.longitude, props.stationData.client_station_id, props.stationData.station_type,props.stationData.visible,props.stationData.is_shared):""} 
        onMouseOut={typeof cardOut === "function"?() => cardOut(props.stationData.latitude, props.stationData.longitude, props.stationData.client_station_id, props.stationData.station_type,props.stationData.visible,props.stationData.is_shared):""}>
              <div className="details-main-info-cnt">
                  {/* {props.export && (props.biCycleCountDate !== "" || props.pedestrianCountDate !== "" || props.turningCountDate !== "")? */}
                  {props.export?
                    <div className='details-main-info-chk'>
                        <div  className={props.export?'list-item-chbx': 'list-item-chbx-hide'}>
                            <StyledCheckbox 
                                value={props.stationData.station_id}
                                checked={props.stationData.checked}
                                onChange={(e) =>{if(props.fnExport){props.fnExport(e, props.stationData)}}}
                                disabled={props.export && (props.biCycleCountDate !== "" || props.pedestrianCountDate !== "" || props.turningCountDate !== "") ? false : true}
                            />
                        </div>
                    </div>
                  :null}
                  <div className='details-main-info-nf' onClick={()=>{if(props.fnDetails){props.fnDetails(props.stationData)}}} style={props.export && (props.biCycleCountDate !== "" || props.pedestrianCountDate !== "" || props.turningCountDate !== "")?{width:'266px'}:{width:'306px'}}>
                      <div className='info-client-id'>
                          {(props.stationData && props.stationData.client_station_id)?props.stationData.client_station_id:null}
                          {props.sharedStation?<span className='lb-share-station'>Shared</span>:null}
                      </div>
                      <div className='info-name' title={(props.stationData && props.stationData.station_location)?props.stationData.station_location:null}>
                          {(props.stationData && props.stationData.station_location)?props.stationData.station_location:null}
                      </div>
                      {
                          (!props.loadingDetails && (props.turningCountDate || props.pedestrianCountDate || props.biCycleCountDate)) ?
                          <div className='info-icons-years'>
                              {props.turningCountDate ?<div className='incon-inf-study' style={{marginRight:'12px'}}>
                              <DataIconsTooltip title="Turning count"><img src={require('../../../assets/icons/turning.png')}/></DataIconsTooltip><span>{props.turningCountDate}</span>
                              </div>:null}
                              {props.pedestrianCountDate ?<div className='incon-inf-study' style={{marginRight:'12px'}}>
                              <DataIconsTooltip title="Pedestrian count"><img src={require('../../../assets/icons/pedestrian.png')}/></DataIconsTooltip><span>{props.pedestrianCountDate}</span>
                              </div>:null}
                              {props.biCycleCountDate ?<div className='incon-inf-study'>
                              <DataIconsTooltip title="Bicycle count"><img src={require('../../../assets/icons/bicycle.png')}/></DataIconsTooltip><span>{props.biCycleCountDate}</span>
                              </div>:null}
                          </div>
                          :null
                      }                                                
                  </div>
                  <div className="details-main-info-mkr icon-img">
                    <span class="helper"></span>                      
                    {
                      props.toggleMarkerBasedOnCapacityLayer ?
                        props.sharedStation ?
                          props.toggleMarkerCapacitySelected === 'AM' ?
                            <object data={props.stationData.capacityam === 1 ?
                              require('../../../assets/icons/map_pin_int_under_shared.svg')
                              :
                              props.stationData.capacityam === 2 ?
                                require('../../../assets/icons/map_pin_int_near_shared.svg')
                                :
                                props.stationData.capacityam === 3 ?
                                  require('../../../assets/icons/map_pin_int_over_shared.svg')
                                  :
                                  require('../../../assets/icons/map_pin_int_gray_shared.svg')}></object>
                            :
                            props.toggleMarkerCapacitySelected === 'MID' ?
                              <object data={props.stationData.capacitymid === 1 ?
                                require('../../../assets/icons/map_pin_int_under_shared.svg')
                                :
                                props.stationData.capacitymid === 2 ?
                                  require('../../../assets/icons/map_pin_int_near_shared.svg')
                                  :
                                  props.stationData.capacitymid === 3 ?
                                    require('../../../assets/icons/map_pin_int_over_shared.svg')
                                    :
                                    require('../../../assets/icons/map_pin_int_gray_shared.svg')}></object>
                              :
                              props.toggleMarkerCapacitySelected === 'PM' ?
                                <object data={props.stationData.capacitypm === 1 ?
                                  require('../../../assets/icons/map_pin_int_under_shared.svg')
                                  :
                                  props.stationData.capacitypm === 2 ?
                                    require('../../../assets/icons/map_pin_int_near_shared.svg')
                                    :
                                    props.stationData.capacitypm === 3 ?
                                      require('../../../assets/icons/map_pin_int_over_shared.svg')
                                      :
                                      require('../../../assets/icons/map_pin_int_gray_shared.svg')}></object>
                                :
                                <object data={require('../../../assets/icons/map_pin_int_gray_shared.svg')}></object>
                          :
                          props.toggleMarkerCapacitySelected === 'AM' ?
                            <object data={props.stationData.capacityam === 1 ?
                              require('../../../assets/icons/under_capacity_normal.svg')
                              :
                              props.stationData.capacityam === 2 ?
                                require('../../../assets/icons/near_capacity_normal.svg')
                                :
                                props.stationData.capacityam === 3 ?
                                  require('../../../assets/icons/over_capacity_normal.svg')
                                  :
                                  require('../../../assets/icons/not_set_2.svg')}></object>
                            :
                            props.toggleMarkerCapacitySelected === 'MID' ?
                              <object data={props.stationData.capacitymid === 1 ?
                                require('../../../assets/icons/under_capacity_normal.svg')
                                :
                                props.stationData.capacitymid === 2 ?
                                  require('../../../assets/icons/near_capacity_normal.svg')
                                  :
                                  props.stationData.capacitymid === 3 ?
                                    require('../../../assets/icons/over_capacity_normal.svg')
                                    :
                                    require('../../../assets/icons/not_set_2.svg')}></object>
                              :
                              props.toggleMarkerCapacitySelected === 'PM' ?
                                <object data={props.stationData.capacitypm === 1 ?
                                  require('../../../assets/icons/under_capacity_normal.svg')
                                  :
                                  props.stationData.capacitypm === 2 ?
                                    require('../../../assets/icons/near_capacity_normal.svg')
                                    :
                                    props.stationData.capacitypm === 3 ?
                                      require('../../../assets/icons/over_capacity_normal.svg')
                                      :
                                      require('../../../assets/icons/not_set_2.svg')}></object>
                                :
                                <object data={require('../../../assets/icons/not_set_2.svg')}></object>
                        :
                        props.toggleMarkerBasedOnLaneGeometryLayer ?
                          props.sharedStation ?
                            <object data={props.stationData.haslane === 0 ?
                              require('../../../assets/icons/not_set_shared.svg')
                              :
                              require('../../../assets/icons/set_shared.svg')}></object>
                            :
                            <object data={props.stationData.haslane === 0 ?
                              require('../../../assets/icons/not_set_2.svg')
                              :
                              require('../../../assets/icons/map_pin_int_2.svg')}></object>
                          :
                          <object data={require('../../../assets/icons/marker_Intersection.svg')}></object>
                    }
                  </div>
              </div>
          </Card>
      )
}

export default StationCard;